import React, { useCallback, useEffect, useRef, useState } from 'react';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

function MarketplaceSummaryScroll({ children }) {
  const scrollRef = useRef(null);
  const [canScrollUp, setCanScrollUp] = useState(false);
  const [canScrollDown, setCanScrollDown] = useState(false);

  const updateScrollState = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    const hasOverflow = el.scrollHeight > el.clientHeight + 2;
    setCanScrollUp(hasOverflow && el.scrollTop > 4);
    setCanScrollDown(hasOverflow && el.scrollTop + el.clientHeight < el.scrollHeight - 4);
  }, []);

  useEffect(() => {
    updateScrollState();
    const el = scrollRef.current;
    if (!el) return undefined;

    el.addEventListener('scroll', updateScrollState);
    const resizeObserver = new ResizeObserver(updateScrollState);
    resizeObserver.observe(el);

    return () => {
      el.removeEventListener('scroll', updateScrollState);
      resizeObserver.disconnect();
    };
  }, [children, updateScrollState]);

  const scrollBy = (delta) => {
    scrollRef.current?.scrollBy({ top: delta, behavior: 'smooth' });
  };

  return (
    <div className='marketplace-summary-scroll'>
      {canScrollUp && (
        <button
          type='button'
          className='marketplace-summary-scroll__btn marketplace-summary-scroll__btn--up'
          onClick={() => scrollBy(-72)}
          aria-label='Scroll summary up'
        >
          <UpOutlined />
        </button>
      )}

      <div className='marketplace-summary-scroll__viewport'>
        {canScrollUp && <div className='marketplace-summary-scroll__fade marketplace-summary-scroll__fade--top' />}
        <div ref={scrollRef} className='marketplace-summary-scroll__content'>
          {children}
        </div>
        {canScrollDown && <div className='marketplace-summary-scroll__fade marketplace-summary-scroll__fade--bottom' />}
      </div>

      {canScrollDown && (
        <button
          type='button'
          className='marketplace-summary-scroll__btn marketplace-summary-scroll__btn--down'
          onClick={() => scrollBy(72)}
          aria-label='Scroll summary down'
        >
          <DownOutlined />
        </button>
      )}
    </div>
  );
}

export default MarketplaceSummaryScroll;
